(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kinder-text-lookbook"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kinder-text-lookbook')) {
    customElements.define('kinder-text-lookbook', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.points = Array.from(this.querySelectorAll('.kinder-lookbook__point'));
        this.timers = new Map();
        this.points.forEach(point => {
          const trigger = point.querySelector('summary');
          point.addEventListener('pointerenter', event => {
            if (event.pointerType === 'mouse') {
              clearTimeout(this.timers.get(point));
              this.openPoint(point);
            }
          }, options);
          trigger.addEventListener('click', event => {
            event.preventDefault();
            if (this.pinnedPoint === point && point.open) {
              this.closeAll();
            } else {
              this.openPoint(point);
              this.pinnedPoint = point;
            }
          }, options);
          point.addEventListener('pointerleave', event => {
            if (event.pointerType === 'mouse' && this.pinnedPoint !== point) {
              this.timers.set(point, setTimeout(() => { point.open = false; }, 160));
            }
          }, options);
          point.addEventListener('toggle', () => {
            if (point.open) this.openPoint(point);
          }, options);
          point.addEventListener('keydown', event => {
            if (event.key === 'Escape') {
              event.preventDefault();
              this.closeAll();
              trigger.focus({ preventScroll: true });
            }
          }, options);
          point.addEventListener('focusout', event => {
            if (!point.contains(event.relatedTarget)) {
              point.open = false;
              if (this.pinnedPoint === point) this.pinnedPoint = null;
            }
          }, options);
          point.querySelector('.kinder-lookbook__close').addEventListener('click', () => {
            this.closeAll();
            trigger.focus({ preventScroll: true });
          }, options);
        });
        document.addEventListener('pointerdown', event => {
          if (!this.points.some(point => point.contains(event.target))) this.closeAll();
        }, options);
        document.addEventListener('shopify:block:select', event => {
          const point = event.target.closest('.kinder-lookbook__point');
          if (point && this.contains(point)) this.openPoint(point);
        }, options);
        document.addEventListener('shopify:block:deselect', event => {
          const point = event.target.closest('.kinder-lookbook__point');
          if (point && this.contains(point)) point.open = false;
        }, options);
        this.observer = new ResizeObserver(() => {
          this.points.filter(point => point.open).forEach(point => this.positionPanel(point));
        });
        this.observer.observe(this);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.timers?.forEach(timer => clearTimeout(timer));
      }
      closeAll(except) {
        if (this.pinnedPoint !== except) this.pinnedPoint = null;
        this.points.forEach(point => {
          clearTimeout(this.timers.get(point));
          if (point !== except) point.open = false;
        });
      }
      openPoint(point) {
        this.closeAll(point);
        point.open = true;
        this.positionPanel(point);
      }
      positionPanel(point) {
        const panel = point.querySelector('.kinder-lookbook__panel');
        const container = this.getBoundingClientRect();
        const anchor = point.getBoundingClientRect();
        const width = panel.offsetWidth;
        const height = panel.offsetHeight;
        const minX = Math.max(16, container.left + 8);
        const maxX = Math.min(document.documentElement.clientWidth - 16, container.right - 8) - width;
        const outwardLeft = anchor.left + anchor.width / 2 < container.left + container.width / 2;
        let x = outwardLeft ? anchor.left - width - 12 : anchor.right + 12;
        if (x < minX) x = anchor.right + 12;
        if (x > maxX) x = anchor.left - width - 12;
        x = Math.max(minX, Math.min(x, Math.max(minX, maxX)));
        const maxY = container.bottom - height - 8;
        const y = Math.max(container.top + 8, Math.min(anchor.top + anchor.height / 2 - height / 2, maxY));
        point.style.setProperty('--panel-x', `${Math.round(x - anchor.left)}px`);
        point.style.setProperty('--panel-y', `${Math.round(y - anchor.top)}px`);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vt-guidelines-catalog"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vt-guidelines-catalog')) {
  customElements.define('vt-guidelines-catalog', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.detailStates = new Map();
      this.filterAnimations = [];
      this.filterRun = 0;
      this.currentTopic = 'all';
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-vtg-filter]');
        if (button && this.contains(button)) {
          if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;
          this.filterGuides(button.dataset.vtgFilter);
          return;
        }
        const summary = event.target.closest('.vtg-details > summary');
        if (summary && this.contains(summary)) {
          event.preventDefault();
          this.toggleDetails(summary.parentElement);
        }
      });
      this.addEventListener('shopify:block:select', () => this.filterGuides('all', false));
      this.applyFilters('all');
    }
    disconnectedCallback() {
      this.filterRun += 1;
      this.clearFilterAnimations();
      this.detailStates?.forEach((state, details) => this.finishDetails(details, state));
    }
    clearFilterAnimations() {
      this.filterAnimations?.forEach((animation) => animation.cancel());
      this.filterAnimations = [];
      const shell = this.querySelector('[data-vtg-catalog-shell]');
      if (shell) {
        shell.style.height = '';
        shell.style.overflow = '';
      }
    }
    applyFilters(topic) {
      let count = 0;
      this.querySelectorAll('[data-vtg-guide]').forEach((guide) => {
        guide.hidden = topic !== 'all' && guide.dataset.topic !== topic;
        if (!guide.hidden) count += 1;
      });
      this.querySelectorAll('[data-vtg-preview]').forEach((preview) => { preview.hidden = topic !== 'all'; });
      this.querySelectorAll('[data-vtg-filter]').forEach((button) => {
        button.setAttribute('aria-pressed', String(!button.disabled && button.dataset.vtgFilter === topic));
      });
      const result = this.querySelector('[data-vtg-results]');
      if (result) result.textContent = count + ' ' + (count === 1 ? this.dataset.resultsOne : this.dataset.resultsMany);
      const empty = this.querySelector('[data-vtg-empty]');
      if (empty) empty.hidden = count !== 0;
    }
    async filterGuides(topic, animate = true) {
      const selected = [...this.querySelectorAll('[data-vtg-filter]')].find((button) => button.dataset.vtgFilter === topic);
      if (!selected || selected.disabled || selected.getAttribute('aria-disabled') === 'true') return;
      if (topic === this.currentTopic && animate) return;
      const run = ++this.filterRun;
      this.currentTopic = topic;
      const catalog = this.querySelector('.vtg-catalog');
      const shell = this.querySelector('[data-vtg-catalog-shell]');
      const height = shell.getBoundingClientRect().height;
      const opacity = getComputedStyle(catalog).opacity;
      this.clearFilterAnimations();
      this.querySelectorAll('[data-vtg-filter]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button === selected));
      });
      if (!animate || this.motion.matches || !catalog.animate) {
        this.applyFilters(topic);
        return;
      }
      shell.style.height = height + 'px';
      shell.style.overflow = 'hidden';
      const fadeOut = catalog.animate([{ opacity }, { opacity: 0 }], { duration: 120, easing: 'ease-out', fill: 'forwards' });
      this.filterAnimations.push(fadeOut);
      await fadeOut.finished.catch(() => {});
      if (run !== this.filterRun || !this.isConnected) return;
      this.applyFilters(topic);
      const nextHeight = catalog.getBoundingClientRect().height;
      const resize = shell.animate([{ height: height + 'px' }, { height: nextHeight + 'px' }], { duration: 300, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'forwards' });
      const fadeIn = catalog.animate([{ opacity: 0, transform: 'translateY(5px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 280, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'forwards' });
      this.filterAnimations.push(resize, fadeIn);
      fadeOut.cancel();
      await Promise.all([resize.finished.catch(() => {}), fadeIn.finished.catch(() => {})]);
      if (run === this.filterRun) this.clearFilterAnimations();
    }
    finishDetails(details, state) {
      state.heightAnimation?.cancel();
      state.fadeAnimation?.cancel();
      details.open = state.opening;
      details.style.height = '';
      details.style.overflow = '';
      delete details.dataset.expanded;
      this.detailStates.delete(details);
    }
    toggleDetails(details) {
      const previous = this.detailStates.get(details);
      const opening = !(previous ? previous.opening : details.open);
      const startHeight = details.getBoundingClientRect().height;
      const content = details.querySelector('.vtg-details-content');
      const startOpacity = details.open ? getComputedStyle(content).opacity : '0';
      previous?.heightAnimation?.cancel();
      previous?.fadeAnimation?.cancel();
      const state = { opening };
      this.detailStates.set(details, state);
      if (this.motion.matches || !details.animate) {
        this.finishDetails(details, state);
        return;
      }
      details.open = true;
      details.style.height = 'auto';
      const summary = details.querySelector('summary');
      const border = parseFloat(getComputedStyle(details).borderTopWidth) + parseFloat(getComputedStyle(details).borderBottomWidth);
      const endHeight = opening ? details.getBoundingClientRect().height : summary.getBoundingClientRect().height + border;
      details.style.height = startHeight + 'px';
      details.style.overflow = 'hidden';
      details.dataset.expanded = String(opening);
      state.heightAnimation = details.animate([{ height: startHeight + 'px' }, { height: endHeight + 'px' }], { duration: 360, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'forwards' });
      state.fadeAnimation = content.animate([{ opacity: startOpacity }, { opacity: opening ? 1 : 0 }], { duration: opening ? 300 : 180, easing: 'ease-out', fill: 'forwards' });
      state.heightAnimation.onfinish = () => {
        if (this.detailStates.get(details) === state) this.finishDetails(details, state);
      };
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vt-health-guidelines"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vt-health-guidelines')) {
  customElements.define('vt-health-guidelines', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-vtg-filter]');
        if (button && this.contains(button)) this.filterGuides(button.dataset.vtgFilter);
      });
      this.addEventListener('shopify:block:select', () => this.filterGuides('all'));
      this.filterGuides('all');
    }
    filterGuides(topic) {
      let count = 0;
      this.querySelectorAll('[data-vtg-guide]').forEach((guide) => {
        guide.hidden = topic !== 'all' && guide.dataset.topic !== topic;
        if (!guide.hidden) count += 1;
      });
      this.querySelectorAll('[data-vtg-filter]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.vtgFilter === topic)));
      const result = this.querySelector('[data-vtg-results]');
      if (result) result.textContent = count + ' ' + (count === 1 ? this.dataset.resultsOne : this.dataset.resultsMany);
      const empty = this.querySelector('[data-vtg-empty]');
      if (empty) empty.hidden = count !== 0;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
